import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import api, { setAccessToken } from "../api/api";
import { Carousel } from "react-bootstrap";
import Slider from "../components/Slider";
import { useRef } from "react";



/* Google OAuth */
import { GoogleLogin } from "@react-oauth/google";

/* Microsoft OAuth */
import { useMsal } from "@azure/msal-react";


export default function Login() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const googleBtnRef = useRef(null);
  const rememberedEmail =
    typeof window !== "undefined" ? localStorage.getItem("remembered_email") || "" : "";

  const [showPassword, setShowPassword] = useState(false);
  /* =========================
     NORMAL LOGIN
  ========================= */
  const handleLogin = async (values, { setSubmitting }) => {
  try {
    const payload = { email: values.email, password: values.password };
    const res = await api.post("/auth/login", payload);

    setAccessToken(res.data.token || res.data.access_token);
    if (values.rememberMe) {
      localStorage.setItem("remembered_email", values.email || "");
    } else {
      localStorage.removeItem("remembered_email");
    }

    toast.success("Login successful");
    navigate("/dashboard", { replace: true });

  } catch (err) {
  const errorMessage = err?.response?.data?.error;

  if (errorMessage?.includes("verify")) {
    try {
      await api.post("/otp/resend", {
        email: values.email,
      });

      toast.info("OTP sent to your email. Please verify.");

      navigate("/verify-otp", {
        state: { email: values.email },
      });

    } catch (otpErr) {
      toast.error("Failed to send OTP");
    }

    return;
  }

  toast.error(errorMessage || "Login failed");
}
 finally {
    setSubmitting(false);
  }
};


  /* =========================
     GOOGLE LOGIN
  ========================= */
  const handleGoogleLogin = async (credentialResponse) => {
    try {
      if (!credentialResponse?.credential) {
        toast.error("Google credential missing");
        return;
      }

      const res = await api.post("/oauth/google/login", {
        credential: credentialResponse.credential,
      });

      setAccessToken(res.data.token || res.data.access_token);

      toast.success("Google login successful");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.error || "Google login failed");
    }
  };

  /* =========================
     MICROSOFT LOGIN
  ========================= */
  const handleMicrosoftLogin = async () => {
    try {
      const response = await instance.loginPopup({
        scopes: ["openid", "profile", "email"],
        prompt: "select_account",
      });

      const res = await api.post("/oauth/microsoft/login", {
        id_token: response.idToken,
      });

      setAccessToken(res.data.token || res.data.access_token);

      toast.success("Microsoft login successful");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error("Microsoft login error:", err);
      toast.error("Microsoft login failed");
    }
  };

  return (
    <main className="login-screen">
      <div className="container">
          <div className="row align-items-center">
        <div className="col-md-6 left-sec">
            <img src="images/logo.svg" className="logo" />


        <h1 className="title1">Login to your Account</h1>
        <div className="subtitle">Welcome back! Select method to log in:</div>

    <div className="social-buttons">
        {/* HIDDEN GOOGLE LOGIN (FUNCTIONALITY SAME) */}
<div style={{ display: "none" }}>
  <GoogleLogin
    onSuccess={handleGoogleLogin}
    onError={() => toast.error("Google login failed")}
    useOneTap={false}
    ref={googleBtnRef}
  />
</div>

{/* CUSTOM GOOGLE BUTTON – SAME DESIGN AS MICROSOFT */}
<button
  type="button"
  className="social-btn"
  onClick={() => {
    const googleButton =
      document.querySelector('div[role="button"]');
    googleButton?.click();
  }}
>
  <img src="icons/google.svg" alt="google" /> Google
</button>

        <button className="social-btn" onClick={handleMicrosoftLogin}>
          <img src="icons/microsoft.svg" alt="microsoft"/> Microsoft
        </button>
    </div>

    <div className="divider">or continue with email</div>
           

          
            <Formik
            initialValues={{
              email: rememberedEmail,
              password: "",
              rememberMe: Boolean(rememberedEmail),
            }}
            validationSchema={Yup.object({
              email: Yup.string().email("Invalid email").required("Required"),
              password: Yup.string().required("Required"),
            })}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form className="login-forms">
                {/* <Field
                  className="form-control mb-2 form_input"
                  name="email"
                  placeholder="Email"
                />
              */}
                <div className="input-wrapper mb-2">
                  <img src="/icons/email.svg" alt="email" className="input-icon left" />

                  <Field
                    className="form-control form_input"
                    name="email"
                    type="email"
                    placeholder="Email"
                  />
                </div>

                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger mb-2 d-block"
                />


               
                
                <div className="input-wrapper mb-2">

  <img src="/icons/shield.svg" className="input-icon left" alt="password" />

  <Field
    type={showPassword ? "text" : "password"}
    className="form-control form_input"
    name="password"
    placeholder="Password"
  />


  <span
    className="input-icon right"
    onClick={() => setShowPassword(!showPassword)}
  >
    <img
      src={
        showPassword
          ? "/icons/eye-slash.png"
          : "/icons/eye1.svg"
      }
      alt="toggle password"
    />
  </span>
</div>

<ErrorMessage
  name="password"
  component="div"
  className="text-danger mb-2 d-block"
/>

     
    <div className="options">
        <label className="custom-checkbox">
          <Field type="checkbox" name="rememberMe" />
          <span className="checkmark"></span>
          Remember me
        </label>

        <Link to="/forgot-password">Forgot password?</Link>
    </div>
                <button
                  className="btn-style1"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Logging in..." : "Login"}
                </button>

      

              <div className="footer-text">
                Don’t have an account? <Link to="/register">Create account</Link>
              </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="col-md-6">
          <Slider className="login-slider">
            <Carousel.Item>
              <img src="images/slide1.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Connect with any device.</h2>
                <p>Everything you need is an internet connection.</p>
              </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item>
              <img src="images/slide2.png" className="img-fluid" />
              <Carousel.Caption>
                <h2>Fast & Secure</h2>
                <p>sdsfsdgfdhgh</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Slider>
        </div>
      </div>
      </div>
    </main>
  );
}
